export default __webpack_public_path__ + "static/media/Lathe EMCO.fc67fefb.png";